import React from "react";

const ZoneMetrics: React.FC = () => (
  <div className="grid grid-cols-2 gap-3 mb-6">
    <div className="bg-gray-100 rounded-xl p-4">
      <p className="text-base text-gray-500">Variación 6 meses</p>
      <p className="text-lg font-bold text-emerald-500">+2.8%</p>
    </div>
    <div className="bg-gray-100 rounded-xl p-4">
      <p className="text-base text-gray-500">Plusvalía</p>
      <p className="text-lg font-bold text-gray-900">Estable</p>
    </div>
  </div>
);

export default ZoneMetrics;
